import { FC } from 'react';
import { useMembersStore } from '../../MembersProvider';
import Nav from './Nav';
import ActiveOverview from '@/components/MembersDay/FY2024/ActivityCom/ActiveOverview';
import FlashSale from '@/components/MembersDay/FY2024/ActivityCom/FlashSale';
import HotBundles from '@/components/MembersDay/FY2024/ActivityCom/HotBundles';
import AUHotBundles from '@/components/MembersDay/FY2024/ActivityCom/AUHotBundles';
import BestSellers from '@/components/MembersDay/FY2024/ActivityCom/BestSellers';
import BannerViewB from '@/components/MembersDay/FY2024/ActivityCom/BannerViewB';
import Accessories from '@/components/MembersDay/FY2024/ActivityCom/Accessories';
import Horizonta from '@/components/MembersDay/FY2024/ActivityCom/JP/Horizonta';
import MixProduct from '@/components/MembersDay/FY2024/ActivityCom/JP/MixProduct';
import PiecesProduct from '@/components/MembersDay/FY2024/ActivityCom/JP/PiecesProduct';
import BagIcon from '@/components/MembersDay/FY2024/ActivityCom/Icon/BagIcon';
import HotIcon from '@/components/MembersDay/FY2024/ActivityCom/Icon/HotIcon';
import StarIcon from '@/components/MembersDay/FY2024/ActivityCom/Icon/StarIcon';
import EcoRedeemRewards from '@/components/MembersDay/FY2024/ActivityCom/eco-redeem-rewards/indexS';
import MembersTimeLine from '@/components/MembersDay/FY2024/Teaser/MembersTimeLine';
import CelebratingUs from '@/components/MembersDay/FY2024/Teaser/CelebratingUs';
import BottomTips from '@/components/MembersDay/FY2024/Teaser/BottomTips';
import Subscribe from '@/components/MembersDay/FY2024/Teaser/Subscribe';
import SubscribeNewProduct from '@/components/MembersDay/FY2024/Teaser/SubscribeNewProduct';
import JoinUs from '@/components/MembersDay/FY2024/Teaser/JoinUs';
import ReferralNext from '@/components/MembersDay/FY2024/Teaser/ReferralNext';
import EcoBenefits from '@/components/MembersDay/FY2024/Teaser/EcoBenefits';
import LoginCard from '@/components/MembersDay/FY2024/ActivityCom/LoginCard';
import getLocal from '@/app/utils/getLocal';
import { ProductModule } from '@/components/MembersDay/type';
import { useLang } from '@/i18n';
import { EU_SITES, NA_SITES } from '@/constants/membersday';

const ActivityCompoment: FC = ({}) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.activity');
    const { isLogin } = useMembersStore();

    /*
        module 后端约定字段
        <HotBundles /> // 左右图文模块
        <BestSellers /> // 每排3个产品
        <BannerViewB /> // banner跳转模块
        <Accessories /> // 每排4个产品
        <Refurbished /> // 轮播产品 
    */
    // BUY_ONE_GET_ONE\PPS_SG\ACCESSORY
    const euComp = () => (
        <>
            <div className="members-day-over"></div>
            <ActiveOverview />
            <div className="members-day-over"></div>
            <Nav />
            <div className="members-day-over has-target"></div>
            <EcoRedeemRewards />
            <FlashSale />
            <HotBundles module={ProductModule.BUY_ONE_GET_ONE} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} />
            <Accessories module={ProductModule.PPS_SG} title={t('product_title3')} desc={t('product_desc3')} icon={<StarIcon />} id="activity-Accessories" />
            <Accessories
                module={ProductModule.ACCESSORY}
                title={t('product_title4')}
                desc={t('product_desc4')}
                icon={<BagIcon />}
                id="activity-Extra-Batteries"
            />
            <div className="members-day-over"></div>
            <CelebratingUs />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            <div className="members-day-over"></div>
            <MembersTimeLine />
            <div className="members-day-over"></div>
            {!isLogin && <LoginCard />}
            <div className="members-day-over"></div>
        </>
    );

    // HOT\BEST_SELLERS\ACCESSORY
    const naComp = () => (
        <>
            <div className="members-day-over"></div>
            <ActiveOverview />
            <div className="members-day-over"></div>
            <Nav />
            <FlashSale />
            <BestSellers module={ProductModule.BEST_SELLERS} title={t('product_title3')} desc={t('product_desc3')} icon={<StarIcon />} />
            <Accessories module={ProductModule.ACCESSORY} title={t('product_title4')} desc={t('product_desc4')} icon={<BagIcon />} id="activity-Accessories" />
            <HotBundles module={ProductModule.HOT} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} />
            <BannerViewB />
            <div className="members-day-over"></div>
            <CelebratingUs />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            <div className="members-day-over"></div>
            <MembersTimeLine />
            <div className="members-day-over"></div>
        </>
    );

    // HOT\BEST_RECOMMEND\ACCESSORY
    const zaComp = () => (
        <>
            {/* <div className="members-day-over"></div>
            <Subscribe />
            <div className="members-day-over"></div> */}
            <Nav />
            <FlashSale />
            <HotBundles module={ProductModule.HOT} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} />
            <Accessories module={ProductModule.BEST_RECOMMEND} title={t('product_title3')} desc={t('product_desc3')} icon={<StarIcon />} />
            <Accessories module={ProductModule.ACCESSORY} title={t('product_title4')} desc={t('product_desc4')} icon={<BagIcon />} />
            <div className="members-day-over"></div>
            <SubscribeNewProduct newProductSub />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            <div className="members-day-over"></div>
            <MembersTimeLine />
            <CelebratingUs />
        </>
    );

    // NORMAL\HOT\ACCESSORY  NORMAL\HOT\ACCESSORY\BEST_RECOMMEND\MEMBER
    const auComp = () => (
        <>
            <div className="members-day-over"></div>
            <MembersTimeLine />
            <div className="members-day-over"></div>
            <Subscribe />
            <div className="members-day-over"></div>
            <Nav />
            <CelebratingUs />
            <AUHotBundles module={ProductModule.BEST_RECOMMEND} title={t('product_title2')} desc={t('product_desc2')} icon={<StarIcon />} />
            <BestSellers module={ProductModule.MEMBER} title={t('product_title5')} desc={t('product_desc5')} icon={<HotIcon />} />
            <BestSellers module={ProductModule.HOT} title={t('product_title3')} desc={t('product_desc3')} icon={<HotIcon />} />
            <Accessories module={ProductModule.ACCESSORY} title={t('product_title4')} desc={t('product_desc4')} icon={<BagIcon />} />
            <BannerViewB />
            <div className="members-day-over"></div>
            <SubscribeNewProduct newProductSub />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            <div className="members-day-over"></div>
        </>
    );

    // MEMBER\BUNDLE\POPULAR
    const jpComp = () => (
        <>
            {/* <div className="members-day-over"></div> */}
            <MembersTimeLine />
            {/* <div className="members-day-over"></div> */}
            <ActiveOverview />
            <div className="members-day-over"></div>
            <Nav />
            <FlashSale />
            <MixProduct module={ProductModule.BUNDLE} title={t('product_title3')} desc={t('product_desc3')} icon={<StarIcon />} />
            <Horizonta module={ProductModule.MEMBER} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} id="activity-HotBundles1" />
            <PiecesProduct module={ProductModule.POPULAR} title={t('product_title4')} desc={t('product_desc4')} icon={<StarIcon />} />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            <div className="members-day-over"></div>
        </>
    );

    // NORMAL\MEMBER
    const krComp = () => (
        <>
            <div className="members-day-over"></div>
            <MembersTimeLine />
            <div className="members-day-over"></div>
            <ActiveOverview />
            <div className="members-day-over"></div>
            <Subscribe />
            <div className="members-day-over"></div>
            <Nav />
            <CelebratingUs />
            <HotBundles module={ProductModule.NORMAL} title={t('product_title2')} desc={t('product_desc2')} icon={<HotIcon />} />
            <BestSellers module={ProductModule.MEMBER} title={t('product_title3')} desc={t('product_desc3')} icon={<BagIcon />} />
            <FlashSale />
            <div className="members-day-over"></div>
            <JoinUs />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="activity" />
            {!isLogin && <LoginCard />}
            <div className="members-day-over"></div>
        </>
    );

    return (
        <div className="page-activity">
            {EU_SITES.includes(locale) && euComp()}
            {NA_SITES.includes(locale) && naComp()}
            {locale === 'za' && zaComp()}
            {locale === 'au' && auComp()}
            {locale === 'jp' && jpComp()}
            {locale === 'kr' && krComp()}
            <BottomTips />
        </div>
    );
};

export default ActivityCompoment;
